var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCustomersImport = function SvgCustomersImport(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.75 39.734",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2611"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2609"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#265fe0",
    "data-name": "Gruppe 2604",
    transform: "translate(0 19.734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5h3.75v10H15z",
    "data-name": "Rechteck 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 5h3.75v8.75H27.5z",
    "data-name": "Rechteck 49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.5h26.75a1 1 0 0 1 1 1v2.75H2.5V3.5a1 1 0 0 1 1-1",
    "data-name": "Rechteck 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5h3.75v8.75H2.5z",
    "data-name": "Rechteck 51"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.75,
    height: 7.5,
    "data-name": "Rechteck 52",
    rx: 1,
    transform: "translate(0 12.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.75,
    height: 7.5,
    "data-name": "Rechteck 53",
    rx: 1,
    transform: "translate(12.5 12.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.75,
    height: 7.5,
    "data-name": "Rechteck 54",
    rx: 1,
    transform: "translate(25 12.5)"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#265fe0",
    opacity: 0.998
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.981 25H9.313a3.313 3.313 0 1 1 0-6.626 1.104 1.104 0 0 1 0 2.209 1.104 1.104 0 0 0 0 2.209h17.668a1.104 1.104 0 1 1 0 2.208",
    "data-name": "Pfad 27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.877 0H9.313A3.313 3.313 0 0 0 6 3.313v18.372l2.209-1.1h17.668a2.21 2.21 0 0 0 2.209-2.209V2.209A2.21 2.21 0 0 0 25.877 0m-8.834 4.665a2.449 2.449 0 1 1-2.449 2.449 2.45 2.45 0 0 1 2.449-2.449m4.41 10.342a.49.49 0 0 1-.491.491l-.065-.013v.013h-7.773a.49.49 0 0 1-.491-.491v-.979a2.45 2.45 0 0 1 2.449-2.449H19a2.45 2.45 0 0 1 2.449 2.449v.979Z",
    "data-name": "Pfad 28"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCustomersImport);
export default ForwardRef;